import { t } from '@lingui/macro';
import { QuoteRequestField } from '@luminovo/http-client';

export function formatQuoteRequestField(field: QuoteRequestField): string {
    switch (field) {
        case 'Ipn':
            return t`IPN`;
        case 'Description':
            return t`Description`;
        case 'Manufacturer':
            return t`Manufacturer`;
        case 'Mpn':
            return t`MPN`;
        case 'Recipient':
            return t`Recipient`;
        case 'RequiredQuantity':
            return t`Required quantity`;
        case 'PotentialQuantity':
            return t`Potential quantity`;
        case 'Unit':
            return t`Unit`;
        case 'Attachment':
            return t`Attachment`;
        case 'Bid':
            return t`Bid`;
        case 'OfferedMpn':
            return t`Offered MPN`;
        case 'OfferedManufacturer':
            return t`Offered manufacturer`;
        case 'UnitPrice':
            return t`Unit price`;
        case 'UnitPriceQuantity':
            return t`Unit price quantity`;
        case 'UnitPriceCurrency':
            return t`Unit price currency`;
        case 'SupplierPartNumber':
            return t`Supplier part number`;
        case 'Packaging':
            return t`Packaging`;
        case 'MinimumOrderQuantity':
            return t`Minimum order quantity`;
        case 'MinimumPackagingQuantity':
            return t`Minimum packaging quantity`;
        case 'LeadTime':
            return t`Lead time`;
        case 'LeadTimeUnit':
            return t`Lead time unit`;
        case 'CancellationWindow':
            return t`Cancellation window`;
        case 'CancellationTimeUnit':
            return t`Cancellation time unit`;
        case 'ItemClass':
            return t`Item class`;
        case 'Ncnr':
            return t`NCNR`;
        case 'Stock':
            return t`Stock`;
        case 'ValidFrom':
            return t`Valid from`;
        case 'ValidUntil':
            return t`Valid until`;
        case 'AdditionalNotes':
            return t`Additional notes`;
        case 'TargetPrice':
            return t`Target price`;
        case 'Customer':
            return t`Customer`;
        case 'NegotiatedByCustomer':
            return t`Negotiated by customer`;
        case 'OneTimeCost':
            return t`One time cost`;
        case 'ValidFor':
            return t`Valid for`;
        case 'CountryOfOrigin':
            return t`Country of origin`;
        case 'EccnNumbers':
            return t`ECCN numbers`;
        case 'HtsCode':
            return t`HTS code`;
        case 'Reach':
            return t`Reach`;
        case 'Rohs':
            return t`RoHS`;
    }
}
